export const DATE = 'dd/MM/yyyy';
export const DATE_SHORT = 'dd/MM';
export const TIME = 'HH:mm';
export const TIME_DATE = 'HH:mm dd/MM/yyyy';
export const TIME_DATE_SHORT = 'HH:mm dd/MM';
export const TIME_DATE_DASH = 'HH:mm - dd/MM/yyyy';
export const TIME_DATE_DOT = 'dd.MM.yyyy - HH:mm';
export const DATE_TIME_SLASH = 'd/L/y - HH:mm';
export const DATE_TIME_SLASH_H = 'd/L/y - H:mm';
